// extracted by mini-css-extract-plugin
module.exports = {"error-view":"ErrorView_error-view__3icwr","title":"ErrorView_title__2pvgv","message":"ErrorView_message__vHalM"};